import { useTranslation } from 'react-i18next';

import PageLayout from '@/components/Layout/PageLayout';

import type { HealthDetailPageId } from '../_config/healthDetailPageConfig';
import { getHealthDetailPageConfig } from '../_config/healthDetailPageConfig';
import HealthDetailDetections from '../components/HealthDetailDetections/HealthDetailDetections';
import HealthDetailInformationPanel from '../components/HealthDetailInformationPanel/HealthDetailInformationPanel';
import HealthDetailTemplate from '../components/HealthDetailTemplate/HealthDetailTemplate';
import HealthDevelopmentChart from '../components/HealthDevelopmentChart/HealthDevelopmentChart';
import HealthStatusChart from '../components/HealthStatusChart/HealthStatusChart';

export interface HealthScaleSkinDetailPageProps {
    pageId: Extract<HealthDetailPageId, 'scaleLoss' | 'skinBleeding'>;
}

export default function HealthScaleSkinDetailPage(props: HealthScaleSkinDetailPageProps) {
    const { pageId } = props;
    const { t } = useTranslation('healthModule');
    const pageConfig = getHealthDetailPageConfig(pageId);

    return (
        <PageLayout title={t(`routes.${pageConfig.routeLabelKey}`)} subtitle={t('routes.health')}>
            <HealthDetailTemplate
                statusChart={
                    <HealthStatusChart healthParameterKey={pageConfig.healthParameterKey} />
                }
                developmentChart={
                    <HealthDevelopmentChart healthParameterKey={pageConfig.healthParameterKey} />
                }
                informationPanel={
                    <HealthDetailInformationPanel
                        healthParameterKey={pageConfig.healthParameterKey}
                        detailNamespace={pageConfig.detailNamespace}
                        routeLabelKey={pageConfig.routeLabelKey}
                    />
                }
                detections={
                    <HealthDetailDetections
                        healthParameterKey={pageConfig.healthParameterKey}
                        laksvelImageIndicator={pageConfig.laksvelImageIndicator}
                    />
                }
            />
        </PageLayout>
    );
}
